import { motion } from "framer-motion";
import { TransparentHBLoadingSpinnerOnly } from "~components";
import { Css } from "~generated/css";

export function LoadingOverlay() {
  return (
    <motion.div
      initial={{ backdropFilter: "blur(0px)" }}
      animate={{ backdropFilter: "blur(.5px)" }}
      exit={{ backdropFilter: "blur(0px)" }}
      css={Css.absolute.top0.left0.w100.h100.df.aic.jcc.z1.$}
    >
      <TransparentHBLoadingSpinnerOnly />
    </motion.div>
  );
}
